export default {
  en: {
    title: "",
  },
  pl: {
    heroHome: {
      subtitle: "<span>48h godzin</span> by zmienić świat",
      description: `Weź udział w technologiczno-ekologicznym hackathonie - ucz się, działaj i wspieraj naszą planetę! Bądź częścią zmiany!`,
      date: "27-29 czerwca 2025 / Gdańsk",
      button: "Weź udział!  &rarr;",
    }
  },
}
